import {useTranslation} from "react-i18next";
// -
import IconBool from "components/IconBool";
import translations from "./translations";
import useCustomTranslation from "core/customTranslation";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableMQTTAdvanced = ({
    items,
    itemsShow,
    buttonsTB,
    setButtonsTB,
    checkAll,
    setCheckAll,
    orderingRef,
}) => {
    const {t: _Tt} = useTranslation("tags");
    const {t: _TC} = useCustomTranslation(translations);

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };
    const stickyHeaderStyle = {
        position: "sticky",
        top: "164px",
        backgroundColor: "white",
        zIndex: 899,
    };

    return (
        <table className="table table-striped sticky-horizontal">
            <thead>
                <tr>
                    <th
                        key="-1"
                        style={{
                            width: "0.4%",
                            verticalAlign: "bottom",
                            ...stickyHeaderStyle,
                        }}
                        className="sticky-top border-bottom-sticky">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} />
                    <th
                        style={{...stickyHeaderStyle}}
                        className="sticky-top border-bottom-sticky">
                        {_Tt("network.server")}
                    </th>
                    <th
                        style={{...stickyHeaderStyle}}
                        className="sticky-top border-bottom-sticky">
                        Topic
                    </th>
                </tr>
            </thead>
            <tbody id="data-list">
                {itemsShow.map((item) => (
                    <tr key={item.id} data-idx={item.id} onChange={onClick}>
                        <td className="align-middle">
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                key={item.id}
                                data-idx={item.id}
                                defaultChecked={items.current.chosen.includes(item.id)}
                                readOnly={true}
                            />
                        </td>
                        <td className="align-middle">{item.name}</td>
                        <td className="align-middle">{item.description}</td>
                        <td className="align-middle">{item.model}</td>
                        <td className="align-middle">
                            <div>
                                <label className="text-muted">{_TC("protocol")}</label>:{" "}
                                {item.values.protocol}
                            </div>
                            <div>
                                <label className="text-muted">{_TC("ip")}</label>:{" "}
                                <IconBool value={item.has.has_ip} classAdd="mx-1" />{" "}
                                {item.values?.ip || "-"}
                            </div>
                            <div>
                                <label className="text-muted">{_TC("port")}</label>:{" "}
                                <IconBool value={item.has.has_port} classAdd="mx-1" />{" "}
                                {item.values?.port || "-"}
                            </div>
                            <div>
                                <label className="text-muted">{_TC("user")}</label>:{" "}
                                <IconBool value={item.has.has_user} classAdd="mx-1" />{" "}
                                {item.values?.user || "-"}
                            </div>
                            <div>
                                <label className="text-muted">{_TC("pass")}</label>:{" "}
                                <IconBool value={item.has.has_pass} classAdd="mx-1" />{" "}
                                {item.values?.pass || "-"}
                            </div>
                        </td>
                        <td className="align-middle">
                            <div>
                                <div className="text-muted">
                                    Topic:{" "}
                                    {_TC("topic.choices." + item.values.type_topic)}
                                </div>
                                <IconBool value={item.has.has_topic} classAdd="mx-1" />{" "}
                                {item.values.topic || "-"}
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableMQTTAdvanced;
